import React from 'react';
import { CheckboxSelector } from '@Knowledge-OTP/znk-ui-components';
import useTranslation from '../../../../i18n/useTranslation';
import FilterBadge from '../../../../common/FilterBadge'

const TypeLessonFilter = (props) => {
  const {
    setFilters = () => {},
    filters = [],
  } = props;
  const { translate } = useTranslation();
  const typeOptions = [
    { name: 'Individual', id: 'individual-lesson' },
    { name: 'Group', id: 'group-lesson' }
  ]

  const checkboxSelectorProps = {
    setDataFilters: setFilters,
    dataFilters: filters,
    direction: 'bottomLeft',
    data: typeOptions,
    typeFilter: 'typeLessons',
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title='Type'
        options={typeOptions}
        selectedIds={filters}
        onClearFilters={() => setFilters([])}
      />
    </CheckboxSelector>
  );
};

export default TypeLessonFilter;
